import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'capitalizeMonth',
})
export class CapitalizeMonthPipe implements PipeTransform {
	transform(value: string | null): string {
		if (!value) {
			return ''; // Ou você pode retornar o valor original, conforme sua necessidade
		}

		// Ajuste a lógica de capitalização conforme necessário
		return value.charAt(0).toUpperCase() + value.slice(1).replace('.', '');
	}
}
